import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ApiService} from "@/modules//dashboard/infra/api.service";
import {DashboardData, DashboardResponse} from "@/modules//dashboard/core/types";
import {ChartConfiguration, ChartOptions} from "chart.js";
import {BarChartComponent} from "@/features/dashboard/components/bar-chart/bar-chart.component";
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-bar-items',
  standalone: true,
  imports: [
    BarChartComponent,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule
  ],
  templateUrl: './bar-items.component.html',
  styleUrl: './bar-items.component.scss'
})
export class BarItemsComponent implements OnInit {

  @ViewChild(BarChartComponent) barChart?: BarChartComponent;
  public apiData: DashboardData[] = []

  public barChartOptions!: ChartOptions
  public barChartData!: ChartConfiguration['data']
  public loading: boolean = false

  @Input() limit: number = 6;
  @Input() expanded: boolean = false;
  @Input() isMonitorMode: boolean = false;

  constructor(private dashboardService: ApiService) {
  }

  ngOnInit(): void {
    this.findAllDataToDashboard();
  }


  findAllDataToDashboard(): void {
    this.loading = true
    this.dashboardService.findAll().subscribe({
      next: (dashData: DashboardResponse<DashboardData>) => {
        this.apiData = dashData.items
        this.setBarChartOptions();
        this.setChartData(dashData.items)
        this.loading = false
      },
      error: (err: Error) => {
        err.message
        this.loading = false
      }
    })
  }


  setBarChartOptions() {
    this.barChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: 'y',
      scales: {
        x: {title: {display: true, text: ''}, grid: {display: false}},
        y: {title: {display: true, text: ''}, grid: {display: false}}
      },
      plugins: {
        legend: {position: 'bottom'}
      }
    }
  }


  setChartData(apiData: DashboardData[]): void {
    const mesesPtBr = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const hoje = new Date();
    const ultimosMeses: { ano: number, mes: number }[] = [];

    for (let i = this.limit - 1; i >= 0; i--) {
      const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
      ultimosMeses.push({ ano: data.getFullYear(), mes: data.getMonth() });
    }

    const contagemPorMes: Record<string, number> = {};
    ultimosMeses.forEach(({ ano, mes }) => {
      const chave = `${ano}-${String(mes + 1).padStart(2, '0')}`;
      contagemPorMes[chave] = 0;
    });


    apiData.forEach(item => {
      const dataItem = new Date(item.formatted_date);
      const chave = `${dataItem.getFullYear()}-${String(dataItem.getMonth() + 1).padStart(2, '0')}`;
      if (contagemPorMes.hasOwnProperty(chave)) {
        contagemPorMes[chave]++;
      }
    });

    const labels = ultimosMeses.map(({ ano, mes }) => `${mesesPtBr[mes]}/${ano}`);
    const data = ultimosMeses.map(({ ano, mes }) => contagemPorMes[`${ano}-${String(mes + 1).padStart(2, '0')}`]);

    this.barChartData = {
      labels: labels,
      datasets: [
        {
          data: data,
          label: 'Check-lists',
          backgroundColor: '#c0142ccc',
          borderColor: '#c0142ccc',
          borderWidth: 1,
          borderRadius: 10
        }
      ]
    };
  }

  public resizeChart(): void {
    this.barChart?.resizeChart();
  }

  public exportChart(): void {
    if (this.barChart && this.barChart.chartDirective && this.barChart.chartDirective.chart) {
      const url = this.barChart.chartDirective.chart.toBase64Image();
      const link = document.createElement('a');
      link.download = 'Check-lists por Mês.png';
      link.href = url;
      link.click();
    }
  }
}
